<template>
	<NewOneOnOneDialog class="global-new-oneonone-dialog"
		:can-validate="newOneOnOneDialog.canValidate"
		:show-dialog="newOneOnOneDialog.isVisible"
		:teammates="newOneOnOneDialog.teammateMatches"
		:show-teammate-suggestions="!!newOneOnOneDialog.teammateMatches.length"
		:teammate-email="newOneOnOneDialog.teammateEmail"
		:teammate-role="newOneOnOneDialog.teammateRole"
		:defer-invitation="newOneOnOneDialog.deferInvitation"
		:errors="newOneOnOneDialog.errors"
		@hide="closeDialog"
		@cancel="closeDialog"
		@submit="onSubmit"
		@change="updateDialog"
	/>
</template>

<script>
import {
	mapActions,
	mapGetters,
	mapMutations
} from "vuex";

import {
	NewOneOnOneDialog
} from "@teaming/common-team";

export default {
	name: "GlobalNewOneOnOneDialogHOC",
	components: {
		NewOneOnOneDialog,
	},
	computed: {
		...mapGetters( "host-dialogs", [
			"newOneOnOneDialog",
		] ),
	},
	methods: {
		...mapMutations( "host-dialogs", {
			closeDialog: "resetNewOneOnOneDialog",
			updateDialog: "updateNewOneOnOneDialog",
		} ),
		...mapActions( "host-dialogs", {
			submitDialog: "submitNewOneOnOneDialog",
		} ),
		async onSubmit( form ) {
			this.updateDialog( form );
			await this.$nextTick();
			this.submitDialog();
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
